var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-tick_signup"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick_signup",
    clipPath: "url(#clip-tick_signup)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9888",
    "data-name": "Group 9888",
    transform: "translate(13015.324 18980.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verified_1_",
    "data-name": "verified(1)",
    transform: "translate(-13015.324 -18980.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4626",
    "data-name": "Group 4626",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4625",
    "data-name": "Group 4625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14548",
    "data-name": "Path 14548",
    d: "M41,71A30,30,0,1,1,71,41,30.035,30.035,0,0,1,41,71Z",
    transform: "translate(-11 -11)",
    fill: "#20bead"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4628",
    "data-name": "Group 4628",
    transform: "translate(17.731 21.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4627",
    "data-name": "Group 4627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14549",
    "data-name": "Path 14549",
    d: "M22.3,31.608a2.484,2.484,0,0,1-1.621-.6L14.87,26.025a2.492,2.492,0,0,1,3.245-3.783l3.992,3.424L31.273,15.8a2.491,2.491,0,1,1,3.653,3.388L24.133,30.807a2.5,2.5,0,0,1-1.83.8Z",
    transform: "translate(-14 -14.999)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSignup);
export default __webpack_public_path__ + "static/media/tick_signup.30213d9ca3c97a7fdb99d24aec2f8649.svg";
export { ForwardRef as ReactComponent };